import React, {Fragment} from 'react';
import image from "../assets/Images/Something.png"

const NotFound = () => {
    return (
        <Fragment>

            <img className="styleImage"  src={image}/>
            
        </Fragment>
    );
};

export default NotFound;